import React, { useContext, useEffect, useState } from 'react';
import { UserDetailsAction, userDetailsReducer } from '../../Reducers/userDetailsReducer';
import { UserDetails } from '../../types/contexts/userContext';
import { GlobalContext } from '../GlobalContext/GlobalContextProvider';
import { getInitialUserDetails } from './userContextFunctions';

interface UserContextInterface {
  userDetailsState: UserDetails;
  dispatchUserDetailsState: React.Dispatch<UserDetailsAction>;
  openIdealMeasuresGeneratorState: boolean;
  setOpenIdealMeasuresGeneratorState: React.Dispatch<React.SetStateAction<boolean>>;
}
export const UserContext = React.createContext<UserContextInterface>({} as UserContextInterface);

const intitialUserDetailsState: UserDetails = getInitialUserDetails();

export default function UserContextProvider(props: { children: React.ReactNode }) {
  // USECONTEXT
  const { setIsLoggedIn, setIsAdmin } = useContext(GlobalContext);
  // USESTATES
  const [openIdealMeasuresGeneratorState, setOpenIdealMeasuresGeneratorState] = useState(
    intitialUserDetailsState.userMeasurements.height === 0
  ); // If we don't have a record of user measurements, then open the ideal measure generator on startup
  // USEREDUCER
  const [userDetailsState, dispatchUserDetailsState] = React.useReducer(
    userDetailsReducer,
    intitialUserDetailsState
  );

  // Update isLoggedIn and isAdmin
  useEffect(() => {
    setIsLoggedIn(userDetailsState.user_id > 0);
  }, [userDetailsState.user_id]);
  useEffect(() => {
    setIsAdmin(userDetailsState.isadmin);
  }, [userDetailsState.isadmin]);

  const value = React.useMemo(
    () => ({
      userDetailsState,
      dispatchUserDetailsState,
      openIdealMeasuresGeneratorState,
      setOpenIdealMeasuresGeneratorState,
    }),
    [userDetailsState, openIdealMeasuresGeneratorState]
  );

  // eslint-disable-next-line react/jsx-no-constructed-context-values
  return <UserContext.Provider value={value} {...props} />;
}
